import React, {createContext, useEffect, useState} from "react";
import {Button} from "tea-component";
import {useAigcIntl} from "@/pages/aigc/utils/utils";
import SvgIcon from "@/pages/home/components/SvgIcon";

export const multipleSegmentGroupContext = createContext({});

export default function MultipleSegment(props) {
  const { name, options=[], showAll=true, value="", onChange} = props;
  const { isExpand } = React.useContext(multipleSegmentGroupContext);
  const {commonFormatMessage} = useAigcIntl("");
  const [expand, setExpand] = useState(false);
  const [isAll, setIsAll] = useState(showAll);
	
  useEffect(() => {
    setExpand(isExpand);
  }, [isExpand]);
	
	
  return (<div className={"aigc-multiple-segment"}>
    <div className={"multiple-segment-left"} style={{height: expand ? "auto" : "46px"}}>
      {name && <span className={"multiple-segment-name"}>{name}</span>}
      <div className={"multiple-segment-wrap"}>
        {showAll && <Button key={"all"} className={isAll ? "active" : ""} onClick={() => {
          setIsAll(true);
          onChange(options?.map(opt => opt?.value) || []);
        }}
        >
          {commonFormatMessage("all")}</Button>}
        {
          options?.map(opt => (
            <Button
              key={opt.value}
              htmlType={"button"}
              className={(!isAll && value?.includes(opt?.value)) ? "active" : ""}
              onClick={() => {
                if (isAll) {
                  onChange([opt.value]);
                  setIsAll(false);
                }else if (value?.includes(opt?.value)) {
                  value?.length > 1 && onChange(value?.filter(v => v !== opt?.value));
                } else {
                  onChange([...value, opt.value]);
                }
								
              }}
            >
              {opt.text}
            </Button>
          ))
        }
      </div>
    </div>
    {
      typeof isExpand !== 'boolean' && (<div className={"multiple-segment-right"}>
        <Button type={"link"} className={"expand-btn"} onClick={() => {setExpand(!expand)}}>{commonFormatMessage(expand ? "retract" : "expand")}&nbsp;<SvgIcon type={expand ? "arrow-up" : "arrow-down"}/></Button>
      </div>)
    }
  </div>);
}